import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminProjectCreate = () => {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        title: '',
        tagline: '',
        description: '',
        status: 'In Development',
        projectUrl: '',
        imageUrl: '',
        slug: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        
        try {
            const token = window.localStorage.getItem('token');
            const res = await fetch('/api/projects', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },
                body: JSON.stringify(form),
            });
            
            if (!res.ok) {
                const text = await res.text();
                throw new Error(text || `Failed to create project: ${res.status}`);
            }
            
            const data = await res.json();
            navigate('/admin/dashboard');
        } catch (err) {
            setError(err.message || 'Unknown error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="text-white">
            <h1>Create Project</h1>
            {error && <div className="text-red-500 mb-16">Error: {error}</div>}
            <form onSubmit={handleSubmit} className="grid gap-12 mt-16" style={{ maxWidth: 640 }}>
                <input className="input-box" name="title" placeholder="Title" value={form.title} onChange={handleChange} required />
                <input className="input-box" name="tagline" placeholder="Tagline" value={form.tagline} onChange={handleChange} />
                <textarea className="input-box" name="description" placeholder="Description" value={form.description} onChange={handleChange} required />
                <input className="input-box" name="status" placeholder="Status" value={form.status} onChange={handleChange} />
                <input className="input-box" name="projectUrl" placeholder="Project URL" value={form.projectUrl} onChange={handleChange} />
                <input className="input-box" name="imageUrl" placeholder="Image URL" value={form.imageUrl} onChange={handleChange} />
                <input className="input-box" name="slug" placeholder="Slug (optional)" value={form.slug} onChange={handleChange} />
                <div className="flex gap-12">
                    <button type="submit" className="px-24 py-12 bg-color-dark text-white br-5" disabled={loading}>
                        {loading ? 'Creating...' : 'Create'}
                    </button>
                    <button type="button" className="px-24 py-12 br-5" onClick={() => navigate('/admin/dashboard')} disabled={loading}>
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AdminProjectCreate;
